<template>
  <section class="our-projects-box" id="our-projects">
    <div
      class="our-projects-box-fixed"
      :style="{
        height: heightCalculation + 'vh',
      }">
      <div class="our-projects-box-fixed-box" ref="fixedBox">
        <div class="section-container-header-box fade-up-animation">
          <p class="list-text">Our products</p>
        </div>
      </div>
    </div>

    <div class="our-projects-box-item" v-for="caseStudy in featuredCaseStudies" :key="caseStudy.name">
      <div class="our-projects-box-item-image">
        <img :src="caseStudy.image" :alt="caseStudy.name" />
      </div>
      <div class="our-projects-box-item-box fade-up-animation">
        <h3 class="extra-large-text text-center" v-html="caseStudy.name"></h3>
        <p class="body-text text-center" v-html="caseStudy.short_description"></p>
        <nuxt-link
          :to="`/projects/${caseStudy.slug}`"
          :aria-label="`Read the ${caseStudy.name} case study`"
          class="arrow-button">
          <p class="list-text-bold">Read case study</p>
          <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div>
        </nuxt-link>
      </div>
    </div>
  </section>
  <div class="our-projects-button-box">
    <nuxt-link to="/projects" aria-label="View all projects" class="arrow-button">
      <p class="list-text-bold">All projects</p>
      <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import icons from '~/icons';
import { featuredCaseStudies } from '@/data/caseStudies';

const fixedBox = useTemplateRef('fixedBox');

const heightCalculation = ref(100);

onMounted(() => {
  window.addEventListener('resize', calculateHeight);
  calculateHeight();
});

function calculateHeight() {
  const baseHeight = (featuredCaseStudies.length - 1) * 100;
  const additionalHeight = fixedBox.value?.offsetHeight || 0;
  const vhHeight = (additionalHeight / window.innerHeight) * 100;
  heightCalculation.value = baseHeight + vhHeight;
}

useFadeUpObserver();
</script>
